export default __webpack_public_path__ + "static/media/lost.3e217025.svg";